import { Box, Typography } from "@mui/material";
import { isTrackedLogisticsAsset } from "../../models/logisticsProgressPayload";
import { getLogisticsMilestoneNextAction } from "../../utils/logisticsMilestoneDetails";

/**
 * What to do next for an asset, from the stage and milestone it is on. Renders nothing for an
 * asset Logistics does not track, or one whose progress has not been merged in.
 *
 * Line height and alignment are set explicitly: the Plants page wrapper passes down
 * `line-height: 120px` and `text-align: center`.
 *
 * @param {object} props
 * @param {object} props.item - an asset with `objectType`, `logisticsStage` and `logisticsMilestone`
 * @param {boolean} [props.compact] - smaller text, for list rows
 * @param {object} [props.sx]
 */
const LogisticsNextAction = ({ item, compact = false, sx }) => {
  if (!isTrackedLogisticsAsset(item) || !item.logisticsStage) return null;

  const nextAction = getLogisticsMilestoneNextAction(
    item.logisticsStage,
    item.logisticsMilestone,
  );
  const textSx = {
    fontSize: compact ? "0.68rem" : "0.72rem",
    lineHeight: 1.3,
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "baseline",
        gap: 0.5,
        minWidth: 0,
        textAlign: "left",
        lineHeight: 1.3,
        ...sx,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          ...textSx,
          flexShrink: 0,
          color: "text.secondary",
          fontWeight: 600,
        }}
      >
        Next
      </Typography>
      <Typography
        variant="caption"
        title={nextAction}
        sx={{
          ...textSx,
          minWidth: 0,
          color: "text.primary",
          fontWeight: 700,
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          overflowWrap: "anywhere",
        }}
      >
        {nextAction}
      </Typography>
    </Box>
  );
};

export default LogisticsNextAction;
